import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Spinner } from '@/components/ui/spinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { currentUser, userProfile, loading } = useAuth();

  // Show loading spinner while auth is initializing OR while we have a user but no profile yet
  if (loading || (currentUser && !userProfile)) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Admin check - must be an admin to access this app
  if (!userProfile?.isAdmin) {
    return (
      <div className="flex h-screen flex-col items-center justify-center bg-background p-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-foreground mb-4">Access Denied</h1>
          <p className="text-muted-foreground mb-8">
            You do not have admin privileges to access this area.
          </p>
          <a
            href={import.meta.env.VITE_DINING_URL || 'http://localhost:3000'}
            className="text-primary hover:underline"
          >
            Return to Dining Steward
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}

